<template>
  <div>
    <!-- <br /> -->
    <div class="row justify-content-center mr-2">
      <div class="col-sm-2 side-bar">
        <ul class="list">
          <li class="list-item item-btn">
            <i class="fas mr-2 fa-chart-area icon"></i>
            <p class="hideable-text-item inline">Overview</p>
          </li>
          <li style="font-weight:100;" class="list-item label text-white">
            Project
          </li>
          <li
            @click="switchTab"
            class="projectsBtn item-btn list-item btnClicked"
          >
            <i class="fas mr-2 fa-tasks inline icon"></i>
            <p class="hideable-text-item inline">Your Projects</p>
          </li>
          <li @click="switchTab1" class="addProjectsBtn list-item item-btn">
            <i class="fas mr-2 fa-plus inline icon"></i>
            <p class="hideable-text-item inline">Add Project</p>
          </li>
          <li style="font-weight:100;" class="list-item label text-white">
            Account
          </li>
          <li @click="switchTab2" class="userInfoBtn list-item item-btn">
            <i class="fas mr-2 fa-user-circle inline icon"></i>
            <p class="hideable-text-item inline">Your Account</p>
          </li>
        </ul>
      </div>
      <br />
      <!--<div class="tab-btns">
        <ul class="list text-left">
          <li class="list-item">
            <router-link to="/">Browse Projects</router-link>
          </li>
          <li @click="switchTab" class="projectsBtn list-item">
            Your Projects
          </li>
          <li @click="switchTab1" class="addProjectsBtn list-item">
            Add Project
          </li>
          <li @click="switchTab2" class="userInfoBtn list-item">
            Your Account
          </li>
        </ul>
      </div>-->
      <div style="padding-right:0!important;" class="col-sm-10 float-right">
        <!-- <div class="announcement">
          <div class="container content">
            <div class="row content">
              <div class="col-sm-12 content">
                <h3 class="text-white text-left">
                  <strong>Notice:</strong> This application is Open source!
                </h3>
                <a
                  href="https://github.com/mouadTaoussi/post-freelance-projects"
                  class="btn btn-sm primary text-white  float-left mr-2"
                  target="_blank"
                >
                  Source Code
                </a>
              </div>
            </div>
          </div>
        </div> -->

        <div class="tabsSections">
          <!-- Dynamic Content  Goes Here -->

          <div class="shadow p-4 my-4 tabs text-left projectsTab">
            <div class="row">
              <div class="col-md-6">
                <h3>
                  <i class="fas mr-4 inline fa-tasks icon-of-each-tab"></i
                  ><strong class="title-of-each-tab">Your Projects</strong>
                </h3>
              </div>
              <div class="col-md-6">
                <button
                  class="btn add-project-first-tab primary inline float-right shadow tabs-btns-right text-white mx-2 btn-sm"
                  @click="switchTab1"
                >
                  Add Project
                </button>
                <button
                  class="btn add-project-first-tab primary inline float-right shadow tabs-btns-right text-white mx-2 btn-sm"
                  @click="switchTab2"
                >
                  Your Account
                </button>
              </div>
            </div>
            <br />
            <!-- <br /> -->
            <!-- Sppiner -->
            <div v-if="projectsDoesntLoaded">
              <center>
                <div class="spinner-grow text-primary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </center>
            </div>
            <div v-else-if="err" class="alert text-left red text-white">
              <i class="fas text-white mr-2 fa-exclamation-triangle"></i
              >{{ " " + errMsg }}
            </div>
            <div class="no-data-svg" v-else-if="!projects">
              <center>
                <svg
                  id="f20e0c25-d928-42cc-98d1-13cc230663ea"
                  data-name="Layer 1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="250"
                  height="250"
                  viewBox="0 0 820.16 780.81"
                >
                  <defs>
                    <linearGradient
                      id="07332201-7176-49c2-9908-6dc4a39c4716"
                      x1="539.63"
                      y1="734.6"
                      x2="539.63"
                      y2="151.19"
                      gradientTransform="translate(-3.62 1.57)"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop offset="0" stop-color="gray" stop-opacity="0.25" />
                      <stop
                        offset="0.54"
                        stop-color="gray"
                        stop-opacity="0.12"
                      />
                      <stop offset="1" stop-color="gray" stop-opacity="0.1" />
                    </linearGradient>
                    <linearGradient
                      id="0ee1ab3f-7ba2-4205-9d4a-9606ad702253"
                      x1="540.17"
                      y1="180.2"
                      x2="540.17"
                      y2="130.75"
                      gradientTransform="translate(-63.92 7.85)"
                      xlink:href="#07332201-7176-49c2-9908-6dc4a39c4716"
                    />
                    <linearGradient
                      id="abca9755-bed1-4a97-b027-7f02ee3ffa09"
                      x1="540.17"
                      y1="140.86"
                      x2="540.17"
                      y2="82.43"
                      gradientTransform="translate(-84.51 124.6) rotate(-12.11)"
                      xlink:href="#07332201-7176-49c2-9908-6dc4a39c4716"
                    />
                    <linearGradient
                      id="2632d424-e666-4ee4-9508-a494957e14ab"
                      x1="476.4"
                      y1="710.53"
                      x2="476.4"
                      y2="127.12"
                      gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
                      xlink:href="#07332201-7176-49c2-9908-6dc4a39c4716"
                    />
                    <linearGradient
                      id="97571ef7-1c83-4e06-b701-c2e47e77dca3"
                      x1="476.94"
                      y1="156.13"
                      x2="476.94"
                      y2="106.68"
                      gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
                      xlink:href="#07332201-7176-49c2-9908-6dc4a39c4716"
                    />
                    <linearGradient
                      id="7d32e13e-a0c7-49c4-af0e-066a2f8cb76e"
                      x1="666.86"
                      y1="176.39"
                      x2="666.86"
                      y2="117.95"
                      gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
                      xlink:href="#07332201-7176-49c2-9908-6dc4a39c4716"
                    />
                  </defs>
                  <title>no data</title>
                  <rect
                    x="317.5"
                    y="142.55"
                    width="437.02"
                    height="603.82"
                    transform="translate(-271.22 62.72) rotate(-12.11)"
                    fill="#e0e0e0"
                  />
                  <g opacity="0.5">
                    <rect
                      x="324.89"
                      y="152.76"
                      width="422.25"
                      height="583.41"
                      transform="translate(-271.22 62.72) rotate(-12.11)"
                      fill="url(#07332201-7176-49c2-9908-6dc4a39c4716)"
                    />
                  </g>
                  <rect
                    x="329.81"
                    y="157.1"
                    width="411.5"
                    height="570.52"
                    transform="translate(-270.79 62.58) rotate(-12.11)"
                    fill="#fafafa"
                  />
                  <rect
                    x="374.18"
                    y="138.6"
                    width="204.14"
                    height="49.45"
                    transform="translate(-213.58 43.93) rotate(-12.11)"
                    fill="url(#0ee1ab3f-7ba2-4205-9d4a-9606ad702253)"
                  />
                  <path
                    d="M460.93,91.9c-15.41,3.31-25.16,18.78-21.77,34.55s18.62,25.89,34,22.58,25.16-18.78,21.77-34.55S476.34,88.59,460.93,91.9ZM470.6,137A16.86,16.86,0,1,1,483.16,117,16.66,16.66,0,0,1,470.6,137Z"
                    transform="translate(-189.92 -59.59)"
                    fill="url(#abca9755-bed1-4a97-b027-7f02ee3ffa09)"
                  />
                  <rect
                    x="375.66"
                    y="136.55"
                    width="199.84"
                    height="47.27"
                    transform="translate(-212.94 43.72) rotate(-12.11)"
                    class="dynamic-svg"
                    fill="#6c63ff"
                  />
                  <path
                    d="M460.93,91.9a27.93,27.93,0,1,0,33.17,21.45A27.93,27.93,0,0,0,460.93,91.9ZM470.17,135a16.12,16.12,0,1,1,12.38-19.14A16.12,16.12,0,0,1,470.17,135Z"
                    transform="translate(-189.92 -59.59)"
                    class="dynamic-svg"
                    fill="#6c63ff"
                  />
                  <rect
                    x="257.89"
                    y="116.91"
                    width="437.02"
                    height="603.82"
                    fill="#e0e0e0"
                  />
                  <g opacity="0.5">
                    <rect
                      x="265.28"
                      y="127.12"
                      width="422.25"
                      height="583.41"
                      fill="url(#2632d424-e666-4ee4-9508-a494957e14ab)"
                    />
                  </g>
                  <rect
                    x="270.65"
                    y="131.42"
                    width="411.5"
                    height="570.52"
                    fill="#fff"
                  />
                  <rect
                    x="374.87"
                    y="106.68"
                    width="204.14"
                    height="49.45"
                    fill="url(#97571ef7-1c83-4e06-b701-c2e47e77dca3)"
                  />
                  <path
                    d="M666.86,118c-15.76,0-28.54,13.08-28.54,29.22s12.78,29.22,28.54,29.22,28.54-13.08,28.54-29.22S682.62,118,666.86,118Zm0,46.08a16.86,16.86,0,1,1,16.46-16.86A16.66,16.66,0,0,1,666.86,164Z"
                    transform="translate(-189.92 -59.59)"
                    fill="url(#7d32e13e-a0c7-49c4-af0e-066a2f8cb76e)"
                  />
                  <rect
                    x="377.02"
                    y="104.56"
                    width="199.84"
                    height="47.27"
                    class="dynamic-svg"
                    fill="#6c63ff"
                  />
                  <path
                    d="M666.86,118a27.93,27.93,0,1,0,27.93,27.93A27.93,27.93,0,0,0,666.86,118Zm0,44.05A16.12,16.12,0,1,1,683,145.89,16.12,16.12,0,0,1,666.86,162Z"
                    transform="translate(-189.92 -59.59)"
                    class="dynamic-svg"
                    fill="#6c63ff"
                  />
                  <g opacity="0.5">
                    <rect
                      x="15.27"
                      y="737.05"
                      width="3.76"
                      height="21.33"
                      fill="#47e6b1"
                    />
                    <rect
                      x="205.19"
                      y="796.65"
                      width="3.76"
                      height="21.33"
                      transform="translate(824.47 540.65) rotate(90)"
                      fill="#47e6b1"
                    />
                  </g>
                  <g opacity="0.5">
                    <rect
                      x="451.49"
                      width="3.76"
                      height="21.33"
                      fill="#47e6b1"
                    />
                    <rect
                      x="641.4"
                      y="59.59"
                      width="3.76"
                      height="21.33"
                      transform="translate(523.63 -632.62) rotate(90)"
                      fill="#47e6b1"
                    />
                  </g>
                  <path
                    d="M961,832.15a4.61,4.61,0,0,1-2.57-5.57,2.22,2.22,0,0,0,.1-.51h0a2.31,2.31,0,0,0-4.15-1.53h0a2.22,2.22,0,0,0-.26.45,4.61,4.61,0,0,1-5.57,2.57,2.22,2.22,0,0,0-.51-.1h0a2.31,2.31,0,0,0-1.53,4.15h0a2.22,2.22,0,0,0,.45.26,4.61,4.61,0,0,1,2.57,5.57,2.22,2.22,0,0,0-.1.51h0a2.31,2.31,0,0,0,4.15,1.53h0a2.22,2.22,0,0,0,.26-.45,4.61,4.61,0,0,1,5.57-2.57,2.22,2.22,0,0,0,.51.1h0a2.31,2.31,0,0,0,1.53-4.15h0A2.22,2.22,0,0,0,961,832.15Z"
                    transform="translate(-189.92 -59.59)"
                    fill="#4d8af0"
                    opacity="0.5"
                  />
                  <path
                    d="M326.59,627.09a4.61,4.61,0,0,1-2.57-5.57,2.22,2.22,0,0,0,.1-.51h0a2.31,2.31,0,0,0-4.15-1.53h0a2.22,2.22,0,0,0-.26.45,4.61,4.61,0,0,1-5.57,2.57,2.22,2.22,0,0,0-.51-.1h0a2.31,2.31,0,0,0-1.53,4.15h0a2.22,2.22,0,0,0,.45.26,4.61,4.61,0,0,1,2.57,5.57,2.22,2.22,0,0,0-.1.51h0a2.31,2.31,0,0,0,4.15,1.53h0a2.22,2.22,0,0,0,.26-.45A4.61,4.61,0,0,1,325,631.4a2.22,2.22,0,0,0,.51.1h0a2.31,2.31,0,0,0,1.53-4.15h0A2.22,2.22,0,0,0,326.59,627.09Z"
                    transform="translate(-189.92 -59.59)"
                    fill="#fdd835"
                    opacity="0.5"
                  />
                  <path
                    d="M855,127.77a4.61,4.61,0,0,1-2.57-5.57,2.22,2.22,0,0,0,.1-.51h0a2.31,2.31,0,0,0-4.15-1.53h0a2.22,2.22,0,0,0-.26.45,4.61,4.61,0,0,1-5.57,2.57,2.22,2.22,0,0,0-.51-.1h0a2.31,2.31,0,0,0-1.53,4.15h0a2.22,2.22,0,0,0,.45.26,4.61,4.61,0,0,1,2.57,5.57,2.22,2.22,0,0,0-.1.51h0a2.31,2.31,0,0,0,4.15,1.53h0a2.22,2.22,0,0,0,.26-.45,4.61,4.61,0,0,1,5.57-2.57,2.22,2.22,0,0,0,.51.1h0a2.31,2.31,0,0,0,1.53-4.15h0A2.22,2.22,0,0,0,855,127.77Z"
                    transform="translate(-189.92 -59.59)"
                    fill="#fdd835"
                    opacity="0.5"
                  />
                  <circle
                    cx="812.64"
                    cy="314.47"
                    r="7.53"
                    fill="#f55f44"
                    opacity="0.5"
                  />
                  <circle
                    cx="230.73"
                    cy="746.65"
                    r="7.53"
                    fill="#f55f44"
                    opacity="0.5"
                  />
                  <circle
                    cx="735.31"
                    cy="477.23"
                    r="7.53"
                    fill="#f55f44"
                    opacity="0.5"
                  />
                  <circle
                    cx="87.14"
                    cy="96.35"
                    r="7.53"
                    fill="#4d8af0"
                    opacity="0.5"
                  />
                  <circle
                    cx="7.53"
                    cy="301.76"
                    r="7.53"
                    fill="#47e6b1"
                    opacity="0.5"
                  />
                </svg>
              </center>
            </div>
            <!-- Project -->
            <div
              v-else
              v-for="(project, index) in projects"
              :key="project"
              class="bg-light project my-2 p-4"
            >
              <div class="row">
                <div class="col-sm-6">
                  <router-link tag="p" :to="'project/' + project._id">
                    <p
                      class="projectTitle "
                      data-toggle="tooltip"
                      data-placement="top"
                      title="View this project"
                    >
                      {{ project.title }}
                    </p>
                  </router-link>
                  <div class="skills ">
                    <p
                      v-for="skill in project.skills"
                      :key="skill"
                      class="skill badge badge-dark"
                    >
                      {{ skill }}
                    </p>
                  </div>
                </div>
                <div class="col-sm-6">
                  <i
                    class="fas fa-ellipsis-v text-dark float-right"
                    id="dropdownMenuButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  ></i>
                  <div
                    class="dropdown-menu shadow"
                    aria-labelledby="dropdownMenuButton"
                  >
                    <br />
                    <ul style="padding-left:0!important;" class="">
                      <li
                        class="dropdown-item"
                        data-toggle="modal"
                        :data-target="'#editModal' + index"
                      >
                        Update
                      </li>
                      <li
                        class="dropdown-item"
                        style="color:red;"
                        data-toggle="modal"
                        :data-target="'#deleteModal' + index"
                      >
                        Delete
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <!-- Button trigger modal -->

              <!-- Modal Edit Project -->
              <div
                class="modal fade"
                :id="'editModal' + index"
                tabindex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div class="modal-dialog" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="exampleModalLabel">
                        {{ project.title }}
                      </h5>
                      <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body">
                      <p>Update the inputs you want!</p>
                      <div class="form">
                        <!-- alert Message -->
                        <div
                          v-if="err"
                          class="alert text-white text-center red"
                        >
                          {{ errMsg }}
                        </div>
                        <!-- Form Here -->
                        <input
                          type="text"
                          :class="'form-control my-2 update-title' + index"
                          name="title"
                          :value="project.title"
                        />
                        <ckeditor
                          :editor="editor"
                          v-model="project.description"
                          :config="editorConfig"
                        ></ckeditor>
                        <textarea
                          type="text"
                          :class="
                            'display-none form-control my-2 update-desc update-description' +
                              index
                          "
                          name="description"
                          v-model="project.description"
                        >
                        </textarea>
                        <input
                          type="text"
                          :class="'form-control my-2 update-skills' + index"
                          name="skills"
                          :value="project.skills.join()"
                        />
                        <select
                          :class="'form-control my-2 update-budget' + index"
                          name="budget"
                          :value="project.budget"
                        >
                          <option value="10$~100$">10$~100$</option>
                          <option value="100$~500$">100$~500$</option>
                          <option value="500$~1000$">500$~1000$</option>
                          <option value="1000$~2000$">1000$~2000$</option>
                          <option value="2000$~3500$">2000$~3500$</option>
                          <option value="3500$~4500$">3500$~4500$</option>
                          <option value="4500$~+5500$">4500$~+5500$</option>
                        </select>
                        <br />
                        <div class="float-right">
                          <button
                            type="button"
                            class="btn m-2 btn-secondary"
                            data-dismiss="modal"
                          >
                            Close
                          </button>
                          <button
                            @click="updateProject(project._id, index)"
                            :class="'edit-btn btn m-2 update-btn' + index"
                          >
                            Update
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- <div class="modal-footer">
                      
                    </div> -->
                  </div>
                </div>
              </div>
              <!--End Modal -->
              <!-- Modal Delete Project -->
              <div
                class="modal fade"
                :id="'deleteModal' + index"
                tabindex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div class="modal-dialog" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="exampleModalLabel">
                        You Sure To Delete This Project?
                      </h5>
                      <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body">
                      <p class="not-bold">
                        Keep the title of the project in the input for make you
                        sure you want to delete this project
                      </p>
                      <strong
                        >NB: If you deleted the input or edit it, the project
                        won't be deleted!
                      </strong>
                      <br />
                      <br />
                      <div class="form">
                        <!-- alert Message -->
                        <div
                          v-if="err"
                          class="alert text-white text-center red"
                        >
                          {{ errMsg }}
                        </div>
                        <!-- Form -->
                        <input
                          type="text"
                          name="title"
                          class="form-control delete-project"
                          :value="project.title"
                          disabled
                        />
                        <br />
                        <div class="float-right">
                          <button
                            @click="deleteProject(project.title, index)"
                            :class="'btn m-2 delete delete-btn' + index"
                          >
                            Delete
                          </button>
                          <button
                            type="button"
                            class="btn m-2 btn-secondary"
                            data-dismiss="modal"
                          >
                            Close
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--End Modal -->
            </div>
            <!--End Project-->
            <!-- No Projects Message Goes Here (if possible)-->
            <p v-if="!projects" class="text-dark text-center">
              Nothing's available for now
            </p>
          </div>
          <!-----------------End Your Projects Tab ------------------>

          <!-------------------------- add project ------------------------------>
          <div
            class="shadow p-4 my-4 display-none tabs text-left addProjectTab"
          >
            <div class="row">
              <div class="col-md-6">
                <h3>
                  <i class="fas mr-4 fa-plus icon-of-each-tab"></i
                  ><strong class="title-of-each-tab">Add Project</strong>
                </h3>
              </div>
              <div class="col-md-6">
                <button
                  class="btn add-project-first-tab primary inline float-right shadow tabs-btns-right text-white mx-2 btn-sm"
                  @click="switchTab"
                >
                  Your Projects
                </button>
                <button
                  class="btn add-project-first-tab primary inline float-right shadow tabs-btns-right text-white mx-2 btn-sm"
                  @click="switchTab2"
                >
                  Your Account
                </button>
              </div>
            </div>
            <br />
            <!-- <br /> -->
            <div class="form">
              <!-- alert Message -->
              <div v-if="err" class="alert text-white text-left red">
                <i class="fas text-white mr-2 fa-exclamation-triangle"></i
                >{{ " " + errMsg }}
              </div>
              <!-- Form Here -->
              <div class="form">
                <label for="Title" class="col-form-label">Title</label>
                <input
                  type="text"
                  class="form-control my-2 add-title"
                  name="title"
                  v-model="title"
                  placeholder="Title Of The Project"
                />
                <label for="description" class="col-form-label"
                  >Description</label
                >
                <ckeditor
                  :editor="editor"
                  v-model="description"
                  :config="editorConfig"
                ></ckeditor>
                <!--<textarea
                  type="text"
                  class="form-control my-2 add-description"
                  name="project_decription"
                  v-model="description"
                  placeholder="What your project about?"
                ></textarea>-->
                <label for="skills" class="col-form-label">skills</label>
                <input
                  type="text"
                  class="form-control my-2 add-skills"
                  name="skills"
                  v-model="skills"
                  placeholder="Enter Needed skills (Separate them by comma)"
                />
                <label for="budget" class="col-form-label">Budget</label>
                <select
                  class="form-control my-2 add-budget"
                  name="budget"
                  v-model="budget"
                  placeholder="Select your budget"
                >
                  <option value="10$~100$">10$~100$</option>
                  <option value="100$~500$">100$~500$</option>
                  <option value="500$~1000$">500$~1000$</option>
                  <option value="1000$~2000$">1000$~2000$</option>
                  <option value="2000$~3500$">2000$~3500$</option>
                  <option value="3500$~4500$">3500$~4500$</option>
                  <option value="4500$~+5500$">4500$~+5500$</option>
                </select>
                <br />

                <button
                  class="btn  form-control addproject-btn"
                  @click="addProject()"
                >
                  Add Project
                </button>
              </div>
            </div>
          </div>
          <!----- End Projects Tab ---->

          <!-------------------------- your account -------------------------------->
          <div class="shadow p-4 my-4 display-none tabs text-left userInfoTab">
            <div class="row">
              <div class="col-md-6">
                <h3>
                  <i class="fas mr-4 fa-user-circle icon-of-each-tab"></i
                  ><strong class="title-of-each-tab">Your Account</strong>
                </h3>
              </div>
              <div class="col-md-6">
                <button
                  class="btn add-project-first-tab primary inline shadow tabs-btns-right float-right text-white mx-2 btn-sm"
                  @click="switchTab"
                >
                  Your Projects
                </button>
                <button
                  class="btn add-project-first-tab primary inline shadow tabs-btns-right float-right text-white mx-2 btn-sm"
                  @click="switchTab1"
                >
                  Add Project
                </button>
              </div>
            </div>
            <br />
            <!-- Sppiner -->
            <div v-if="userInfoDoesntLoaded">
              <center>
                <div class="spinner-grow text-primary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </center>
            </div>
            <!-- <br> -->
            <div v-else class="form">
              <div class="alert-larger-devices">
                <div v-if="err" class="alert text-left red text-white errMsg">
                  <i class="fas text-white mr-2 fa-exclamation-triangle"></i
                  >{{ " " + errMsg }}
                </div>
                <div v-if="msg" class="alert success text-white ">
                  <i class="fas text-white fa-check-circle"></i
                  >{{ " " + successMsg }}
                </div>
              </div>
              <!-- Project -->
              <div class="row justify-content-center">
                <div class="col-md-6">
                  <label for="name" class="col-form-label">Name</label>
                  <input
                    name="name"
                    type="text"
                    :value="userInfo.name"
                    id="name"
                    class="form-control form-control-sm my-2"
                  />
                  <label for="email" class="col-form-label">Email</label>
                  <input
                    disabled
                    name="email"
                    type="email"
                    :value="userInfo.email"
                    id="email"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="You mustn't update your email"
                    class="form-control form-control-sm my-2"
                  />
                  <label for="skills" class="col-form-label">Skills</label>
                  <input
                    name="skills"
                    type="text"
                    id="skills"
                    :value="userInfo.skills"
                    class="form-control form-control-sm my-2"
                  />
                  <label for="name" class="col-form-label">First Language</label>
                  <select
                    :value="userInfo.languages[0].motherLanguage"
                    name="motherLanguage"
                    id="motherLanguage"
                    class="form-control motherLanguage"
                  >
                    <option value="En">English</option>
                    <option value="Fr">French</option>
                    <option value="It">Italian</option>
                    <option value="Es">Spanish</option>
                    <option value="Pr">Portuguez</option>
                    <option value="Da">Dautch</option>
                    <option value="Ar">Arabic</option>
                  </select>
                  <label for="name" class="col-form-label">Second Language</label>
                  <select
                    :value="userInfo.languages[0].secondLanguage"
                    name="secondLanguage"
                    id="secondLanguage"
                    class="form-control secondLanguage"
                  >
                    <option value="En">English</option>
                    <option value="Fr">French</option>
                    <option value="It">Italian</option>
                    <option value="Es">Spanish</option>
                    <option value="Pr">Portuguez</option>
                    <option value="Da">Dautch</option>
                    <option value="Ar">Arabic</option>
                  </select>
                  <label for="name" class="col-form-label">Third Language</label>
                  <select
                    :value="userInfo.languages[0].thirdLanguage"
                    name="thirdLanguage"
                    id="thirdLanguage"
                    class="form-control thirdLanguage"
                  >
                    <option value="En">English</option>
                    <option value="Fr">French</option>
                    <option value="It">Italian</option>
                    <option value="Es">Spanish</option>
                    <option value="Pr">Portuguez</option>
                    <option value="Da">Dautch</option>
                    <option value="Ar">Arabic</option>
                  </select>

                  <label for="phone" class="col-form-label">Phone</label>
                  <input
                    name="phone"
                    type="text"
                    :value="userInfo.phone"
                    id="phone"
                    class="form-control form-control-sm my-2"
                  />
                  <label for="address" class="col-form-label">address</label>
                  <input
                    name="address"
                    type="text"
                    :value="userInfo.address"
                    id="address"
                    class="form-control form-control-sm my-2"
                  />
                </div>
                <div class="col-md-6">
                  <label for="phone" class="col-form-label">Phone</label>
                  <input
                    name="phone"
                    type="text"
                    :value="userInfo.phone"
                    id="phone"
                    class="form-control form-control-sm my-2"
                  />
                  <label for="address" class="col-form-label">address</label>
                  <input
                    name="address"
                    type="text"
                    :value="userInfo.address"
                    id="address"
                    class="form-control form-control-sm my-2"
                  />
                  <label for="zipCode" class="col-form-label">Zip Code</label>
                  <input
                    name="zipCode"
                    type="text"
                    :value="userInfo.zipCode"
                    id="zipCode"
                    class="form-control form-control-sm my-2"
                  />
                  <label for="city" class="col-form-label">City</label>
                  <input
                    name="city"
                    type="text"
                    :value="userInfo.city"
                    id="city"
                    class="form-control form-control-sm my-2"
                  />
                  <label for="country" class="col-form-label">Country</label>
                  <select
                    name="country"
                    id="country"
                    :value="userInfo.country"
                    class="form-control form-control-sm my-2"
                  >
                    <option value="Afghanistan">Afghanistan</option>
                    <option value="Åland Islands">Åland Islands</option>
                    <option value="Albania">Albania</option>
                    <option value="Algeria">Algeria</option>
                    <option value="American Samoa">American Samoa</option>
                    <option value="Andorra">Andorra</option>
                    <option value="Angola">Angola</option>
                    <option value="Anguilla">Anguilla</option>
                    <option value="Antarctica">Antarctica</option>
                    <option value="Antigua and Barbuda"
                      >Antigua and Barbuda</option
                    >
                    <option value="Argentina">Argentina</option>
                    <option value="Armenia">Armenia</option>
                    <option value="Aruba">Aruba</option>
                    <option value="Australia">Australia</option>
                    <option value="Austria">Austria</option>
                    <option value="Azerbaijan">Azerbaijan</option>
                    <option value="Bahamas">Bahamas</option>
                    <option value="Bahrain">Bahrain</option>
                    <option value="Bangladesh">Bangladesh</option>
                    <option value="Barbados">Barbados</option>
                    <option value="Belarus">Belarus</option>
                    <option value="Belgium">Belgium</option>
                    <option value="Belize">Belize</option>
                    <option value="Benin">Benin</option>
                    <option value="Bermuda">Bermuda</option>
                    <option value="Bhutan">Bhutan</option>
                    <option value="Bolivia">Bolivia</option>
                    <option value="Bosnia and Herzegovina"
                      >Bosnia and Herzegovina</option
                    >
                    <option value="Botswana">Botswana</option>
                    <option value="Bouvet Island">Bouvet Island</option>
                    <option value="Brazil">Brazil</option>
                    <option value="British Indian Ocean Territory"
                      >British Indian Ocean Territory</option
                    >
                    <option value="Brunei Darussalam">Brunei Darussalam</option>
                    <option value="Bulgaria">Bulgaria</option>
                    <option value="Burkina Faso">Burkina Faso</option>
                    <option value="Burundi">Burundi</option>
                    <option value="Cambodia">Cambodia</option>
                    <option value="Cameroon">Cameroon</option>
                    <option value="Canada">Canada</option>
                    <option value="Cape Verde">Cape Verde</option>
                    <option value="Cayman Islands">Cayman Islands</option>
                    <option value="Central African Republic"
                      >Central African Republic</option
                    >
                    <option value="Chad">Chad</option>
                    <option value="Chile">Chile</option>
                    <option value="China">China</option>
                    <option value="Christmas Island">Christmas Island</option>
                    <option value="Cocos (Keeling) Islands"
                      >Cocos (Keeling) Islands</option
                    >
                    <option value="Colombia">Colombia</option>
                    <option value="Comoros">Comoros</option>
                    <option value="Congo">Congo</option>
                    <option value="Congo, The Democratic Republic of The"
                      >Congo, The Democratic Republic of The</option
                    >
                    <option value="Cook Islands">Cook Islands</option>
                    <option value="Costa Rica">Costa Rica</option>
                    <option value="Cote D'ivoire">Cote D'ivoire</option>
                    <option value="Croatia">Croatia</option>
                    <option value="Cuba">Cuba</option>
                    <option value="Cyprus">Cyprus</option>
                    <option value="Czech Republic">Czech Republic</option>
                    <option value="Denmark">Denmark</option>
                    <option value="Djibouti">Djibouti</option>
                    <option value="Dominica">Dominica</option>
                    <option value="Dominican Republic"
                      >Dominican Republic</option
                    >
                    <option value="Ecuador">Ecuador</option>
                    <option value="Egypt">Egypt</option>
                    <option value="El Salvador">El Salvador</option>
                    <option value="Equatorial Guinea">Equatorial Guinea</option>
                    <option value="Eritrea">Eritrea</option>
                    <option value="Estonia">Estonia</option>
                    <option value="Ethiopia">Ethiopia</option>
                    <option value="Falkland Islands (Malvinas)"
                      >Falkland Islands (Malvinas)</option
                    >
                    <option value="Faroe Islands">Faroe Islands</option>
                    <option value="Fiji">Fiji</option>
                    <option value="Finland">Finland</option>
                    <option value="France">France</option>
                    <option value="French Guiana">French Guiana</option>
                    <option value="French Polynesia">French Polynesia</option>
                    <option value="French Southern Territories"
                      >French Southern Territories</option
                    >
                    <option value="Gabon">Gabon</option>
                    <option value="Gambia">Gambia</option>
                    <option value="Georgia">Georgia</option>
                    <option value="Germany">Germany</option>
                    <option value="Ghana">Ghana</option>
                    <option value="Gibraltar">Gibraltar</option>
                    <option value="Greece">Greece</option>
                    <option value="Greenland">Greenland</option>
                    <option value="Grenada">Grenada</option>
                    <option value="Guadeloupe">Guadeloupe</option>
                    <option value="Guam">Guam</option>
                    <option value="Guatemala">Guatemala</option>
                    <option value="Guernsey">Guernsey</option>
                    <option value="Guinea">Guinea</option>
                    <option value="Guinea-bissau">Guinea-bissau</option>
                    <option value="Guyana">Guyana</option>
                    <option value="Haiti">Haiti</option>
                    <option value="Heard Island and Mcdonald Islands"
                      >Heard Island and Mcdonald Islands</option
                    >
                    <option value="Holy See (Vatican City State)"
                      >Holy See (Vatican City State)</option
                    >
                    <option value="Honduras">Honduras</option>
                    <option value="Hong Kong">Hong Kong</option>
                    <option value="Hungary">Hungary</option>
                    <option value="Iceland">Iceland</option>
                    <option value="India">India</option>
                    <option value="Indonesia">Indonesia</option>
                    <option value="Iran, Islamic Republic of"
                      >Iran, Islamic Republic of</option
                    >
                    <option value="Iraq">Iraq</option>
                    <option value="Ireland">Ireland</option>
                    <option value="Isle of Man">Isle of Man</option>
                    <option value="Israel">Israel</option>
                    <option value="Italy">Italy</option>
                    <option value="Jamaica">Jamaica</option>
                    <option value="Japan">Japan</option>
                    <option value="Jersey">Jersey</option>
                    <option value="Jordan">Jordan</option>
                    <option value="Kazakhstan">Kazakhstan</option>
                    <option value="Kenya">Kenya</option>
                    <option value="Kiribati">Kiribati</option>
                    <option value="Korea, Democratic People's Republic of"
                      >Korea, Democratic People's Republic of</option
                    >
                    <option value="Korea, Republic of"
                      >Korea, Republic of</option
                    >
                    <option value="Kuwait">Kuwait</option>
                    <option value="Kyrgyzstan">Kyrgyzstan</option>
                    <option value="Lao People's Democratic Republic"
                      >Lao People's Democratic Republic</option
                    >
                    <option value="Latvia">Latvia</option>
                    <option value="Lebanon">Lebanon</option>
                    <option value="Lesotho">Lesotho</option>
                    <option value="Liberia">Liberia</option>
                    <option value="Libyan Arab Jamahiriya"
                      >Libyan Arab Jamahiriya</option
                    >
                    <option value="Liechtenstein">Liechtenstein</option>
                    <option value="Lithuania">Lithuania</option>
                    <option value="Luxembourg">Luxembourg</option>
                    <option value="Macao">Macao</option>
                    <option value="Macedonia, The Former Yugoslav Republic of"
                      >Macedonia, The Former Yugoslav Republic of</option
                    >
                    <option value="Madagascar">Madagascar</option>
                    <option value="Malawi">Malawi</option>
                    <option value="Malaysia">Malaysia</option>
                    <option value="Maldives">Maldives</option>
                    <option value="Mali">Mali</option>
                    <option value="Malta">Malta</option>
                    <option value="Marshall Islands">Marshall Islands</option>
                    <option value="Martinique">Martinique</option>
                    <option value="Mauritania">Mauritania</option>
                    <option value="Mauritius">Mauritius</option>
                    <option value="Mayotte">Mayotte</option>
                    <option value="Mexico">Mexico</option>
                    <option value="Micronesia, Federated States of"
                      >Micronesia, Federated States of</option
                    >
                    <option value="Moldova, Republic of"
                      >Moldova, Republic of</option
                    >
                    <option value="Monaco">Monaco</option>
                    <option value="Mongolia">Mongolia</option>
                    <option value="Montenegro">Montenegro</option>
                    <option value="Montserrat">Montserrat</option>
                    <option value="Morocco">Morocco</option>
                    <option value="Mozambique">Mozambique</option>
                    <option value="Myanmar">Myanmar</option>
                    <option value="Namibia">Namibia</option>
                    <option value="Nauru">Nauru</option>
                    <option value="Nepal">Nepal</option>
                    <option value="Netherlands">Netherlands</option>
                    <option value="Netherlands Antilles"
                      >Netherlands Antilles</option
                    >
                    <option value="New Caledonia">New Caledonia</option>
                    <option value="New Zealand">New Zealand</option>
                    <option value="Nicaragua">Nicaragua</option>
                    <option value="Niger">Niger</option>
                    <option value="Nigeria">Nigeria</option>
                    <option value="Niue">Niue</option>
                    <option value="Norfolk Island">Norfolk Island</option>
                    <option value="Northern Mariana Islands"
                      >Northern Mariana Islands</option
                    >
                    <option value="Norway">Norway</option>
                    <option value="Oman">Oman</option>
                    <option value="Pakistan">Pakistan</option>
                    <option value="Palau">Palau</option>
                    <option value="Palestinian Territory, Occupied"
                      >Palestinian Territory, Occupied</option
                    >
                    <option value="Panama">Panama</option>
                    <option value="Papua New Guinea">Papua New Guinea</option>
                    <option value="Paraguay">Paraguay</option>
                    <option value="Peru">Peru</option>
                    <option value="Philippines">Philippines</option>
                    <option value="Pitcairn">Pitcairn</option>
                    <option value="Poland">Poland</option>
                    <option value="Portugal">Portugal</option>
                    <option value="Puerto Rico">Puerto Rico</option>
                    <option value="Qatar">Qatar</option>
                    <option value="Reunion">Reunion</option>
                    <option value="Romania">Romania</option>
                    <option value="Russian Federation"
                      >Russian Federation</option
                    >
                    <option value="Rwanda">Rwanda</option>
                    <option value="Saint Helena">Saint Helena</option>
                    <option value="Saint Kitts and Nevis"
                      >Saint Kitts and Nevis</option
                    >
                    <option value="Saint Lucia">Saint Lucia</option>
                    <option value="Saint Pierre and Miquelon"
                      >Saint Pierre and Miquelon</option
                    >
                    <option value="Saint Vincent and The Grenadines"
                      >Saint Vincent and The Grenadines</option
                    >
                    <option value="Samoa">Samoa</option>
                    <option value="San Marino">San Marino</option>
                    <option value="Sao Tome and Principe"
                      >Sao Tome and Principe</option
                    >
                    <option value="Saudi Arabia">Saudi Arabia</option>
                    <option value="Senegal">Senegal</option>
                    <option value="Serbia">Serbia</option>
                    <option value="Seychelles">Seychelles</option>
                    <option value="Sierra Leone">Sierra Leone</option>
                    <option value="Singapore">Singapore</option>
                    <option value="Slovakia">Slovakia</option>
                    <option value="Slovenia">Slovenia</option>
                    <option value="Solomon Islands">Solomon Islands</option>
                    <option value="Somalia">Somalia</option>
                    <option value="South Africa">South Africa</option>
                    <option value="South korea">South korea</option>
                    <option value="South Georgia and The South Sandwich Islands"
                      >South Georgia and The South Sandwich Islands</option
                    >
                    <option value="Spain">Spain</option>
                    <option value="Sri Lanka">Sri Lanka</option>
                    <option value="Sudan">Sudan</option>
                    <option value="Suriname">Suriname</option>
                    <option value="Svalbard and Jan Mayen"
                      >Svalbard and Jan Mayen</option
                    >
                    <option value="Swaziland">Swaziland</option>
                    <option value="Sweden">Sweden</option>
                    <option value="Switzerland">Switzerland</option>
                    <option value="Syrian Arab Republic"
                      >Syrian Arab Republic</option
                    >
                    <option value="Taiwan, Province of China"
                      >Taiwan, Province of China</option
                    >
                    <option value="Tajikistan">Tajikistan</option>
                    <option value="Tanzania, United Republic of"
                      >Tanzania, United Republic of</option
                    >
                    <option value="Thailand">Thailand</option>
                    <option value="Timor-leste">Timor-leste</option>
                    <option value="Togo">Togo</option>
                    <option value="Tokelau">Tokelau</option>
                    <option value="Tonga">Tonga</option>
                    <option value="Trinidad and Tobago"
                      >Trinidad and Tobago</option
                    >
                    <option value="Tunisia">Tunisia</option>
                    <option value="Turkey">Turkey</option>
                    <option value="Turkmenistan">Turkmenistan</option>
                    <option value="Turks and Caicos Islands"
                      >Turks and Caicos Islands</option
                    >
                    <option value="Tuvalu">Tuvalu</option>
                    <option value="Uganda">Uganda</option>
                    <option value="Ukraine">Ukraine</option>
                    <option value="United Arab Emirates"
                      >United Arab Emirates</option
                    >
                    <option value="United Kingdom">United Kingdom</option>
                    <option value="United States">United States</option>
                    <option value="United States Minor Outlying Islands"
                      >United States Minor Outlying Islands</option
                    >
                    <option value="Uruguay">Uruguay</option>
                    <option value="Uzbekistan">Uzbekistan</option>
                    <option value="Vanuatu">Vanuatu</option>
                    <option value="Venezuela">Venezuela</option>
                    <option value="Viet Nam">Viet Nam</option>
                    <option value="Virgin Islands, British"
                      >Virgin Islands, British</option
                    >
                    <option value="Virgin Islands, U.S."
                      >Virgin Islands, U.S.</option
                    >
                    <option value="Wallis and Futuna">Wallis and Futuna</option>
                    <option value="Western Sahara">Western Sahara</option>
                    <option value="Yemen">Yemen</option>
                    <option value="Zambia">Zambia</option>
                    <option value="Zimbabwe">Zimbabwe</option>
                  </select>
                  <label for="password" class="col-form-label">Password</label>
                  <input
                    name="password"
                    type="password"
                    id="password"
                    :value="userInfo.password"
                    class="form-control form-control-sm my-2 passwordInput"
                  />
                  <!-- An element to toggle between password visibility -->
                  <input
                    type="checkbox"
                    class=""
                    @click="togglePassword()"
                  />Show Password
                </div>
              </div>
              <br />
              <div class="alert-smaller-devices">
                <div v-if="err" class="alert text-left red text-white errMsg">
                  <i class="fas text-white mr-2 fa-exclamation-triangle"></i
                  >{{ " " + errMsg }}
                </div>
                <div v-if="msg" class="alert success text-white ">
                  <i class="fas text-white fa-check-circle"></i
                  >{{ " " + successMsg }}
                </div>
              </div>
              <button
                type="button"
                class="btn primary text-white updateUserInfo"
                @click="updateUserInfo()"
              >
                Save Changes
              </button>
            </div>
          </div>
          <!--- End Your Account Tab -->
        </div>
      </div>
      <!--End Boostsrap Col-->
    </div>
  </div>
</template>

<script>
// IMPORT LINKS FILE
const link = require("../.././api.links.config.js");
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  name: "dashboard",

  data() {
    return {
      token: window.localStorage.getItem("access-token") || false, // TOKEN

      phoneREGEX: /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,

      zipCodeREGEX: /^[0-9]{5}(?:-[0-9]{4})?$/,

      projectsDoesntLoaded: true,

      userInfoDoesntLoaded: true,

      projects: null,

      userInfo: null,

      title: null,

      description: null,

      skills: null,

      budget: null,

      Msg: null,

      err: false,

      errMsg: null,

      successMsg: null,

      msg: false,

      editor: ClassicEditor,

      editorConfig: {
        // The configuration of the editor.
      },
    };
  },
  created() {
    // auth stuff goes here...
    // INIT AN LOCAL ARRAY THE CAUSE IS WE CANNOT USE this KEYWORD INNER ARROW  FUNCTIONS
    let projectsAfterProcess = [];
    // let userData = '';

    // CHECK IF USER LOGGED IN
    if (!this.token) {
      this.$router.push("login");
    }

    // Fetch User Projects
    this.$http({
      method: "get",
      url: link.baselink + "/dashboard/" + this.token,
      headers: {
        // 'Access-Control-Request-Headers':'access-token',
        // "Access-Control-Allow-Origin": "*",
        // "Access-Control-Allow-Credentials":"true",
        // 'access-token':this.token
      },
    })
      .then((res) => {
        for (var i = 0; i < res.data.Projects.length; i++) {
          // console.log(res.data.Projects[i]); // ARRAY

          const project_data = {
            _id: res.data.Projects[i]._id,

            title: res.data.Projects[i].title,

            user_email: res.data.Projects[i].user_email,

            description: res.data.Projects[i].description,

            skills: res.data.Projects[i].skills.split(","),

            budget: res.data.Projects[i].budget,
          };

          // PUSH DATA TO A LOCAL VARIABLE CUSE WE CANNOT USE THIS KEYWORD IN ARROW FUNCTIONS
          // OR CALLBACK AND WE ARE IN A CALLBACK FUNCTION RIGHT NOW <inside callback function .then()>
          projectsAfterProcess.push(project_data);
        }
        // PUSH DATA TO GLOBAL VARIABLE
        this.userInfo = res.data.userInfo;

        //console.log(res.data.Projects.length); // JSON OBJECT
        //console.log(projectsAfterProcess.length); // JSON OBJECT

        // TURN OFF THE SPINNER
        if (projectsAfterProcess.length == 0) {
          this.projectsDoesntLoaded = false;

          this.projects = false;

          if (this.userInfo) {
            this.userInfoDoesntLoaded = false;
          }
        } else if (projectsAfterProcess.length > 0) {
          this.projectsDoesntLoaded = false;

          // this.projects = false;

          if (this.userInfo) {
            this.userInfoDoesntLoaded = false;
          }
        }
        /*else if( !projectsAfterProcess ) {
          console.log('equal 0')

          this.projectsDoesntLoaded = false;

        }*/
      })
      .catch(() => {
        // TURN OFF THE SPINNER
        this.projectsDoesntLoaded = false;
        this.userInfoDoesntLoaded = false;

        // Something Goes Here ...

        // SHOW ALERT MESSAGE
        this.errMsg = "Something went wrong! Try Again.";
        this.err = true;

        // CHANGE BUTTON BACK CONTENT
        document.querySelector(".update-btn").innerHTML = `Update`;
      });

    // PUT PROJECTS TO GLOBAL ARRAY
    this.projects = projectsAfterProcess;
  },
  methods: {
    // update project
    updateProject: function(id, index) {
      // GET DATA FROM HTML INPUTS
      const title = document.querySelector(".update-title" + index).value,
        description = document.querySelector(".update-description" + index)
          .value,
        skills = document.querySelector(".update-skills" + index).value,
        budget = document.querySelector(".update-budget" + index).value;

      // VALIDATE DATA
      if (title === "") {
        document.querySelector(".update-title").style.border = ".5px solid red";
      } else if (description === "") {
        document.querySelector(".update-description").style.border =
          ".5px solid red";
      } else if (skills === "") {
        document.querySelector(".update-skills").style.border =
          ".5px solid red";
      } else if (budget === "") {
        document.querySelector(".update-budget").style.border =
          ".5px solid red";
      } else {
        // CHANGE BTN CONTENT
        document.querySelector(
          ".update-btn" + index
        ).innerHTML = `<span class="spinner-grow spinner-grow-sm text-white" role="status" aria-hidden="true"></span>
            Please Wait...`;

        // UPDATE DATA
        this.$http({
          method: "post",
          url: link.baselink + `/project/update/${id}/${this.token}`,
          data: {
            title: title,

            description: description,

            skills: skills,

            budget: budget,
          },
        })
          .then((res) => {
            if (res.data.updated) {
              // RELOAD WINDOW
              window.location.reload();
            }
          })
          .catch(() => {
            // Something Goes Here...
            // CHANGE BUTTON BACK CONTENT
            document.querySelector(".update-btn").innerHTML = `Update`;

            // SHOW ALERT MESSAGE
            this.errMsg = "Something went wrong! Try Again.";
            this.err = true;

            // CHANGE BUTTON BACK CONTENT
            document.querySelector(".update-btn").innerHTML = `Update`;

            // HIDE ALERT AFTER 3 SECONDS
            window.setInterval(() => {
              this.errMsg = null;
              this.err = false;
            }, 5000);
          });
      }
    },
    // add project
    addProject: function() {
      if (this.title == null) {
        document.querySelector(".add-title").style.border = ".5px solid red";
      } else if (this.description == null) {
        document.querySelector(".add-description").style.border =
          ".5px solid red";
      } else if (this.skills == null) {
        document.querySelector(".add-skills").style.border = ".5px solid red";
      } else if (this.budget == null) {
        /* else if ( !this.skills.includes(',') ){
        document.querySelector('.add-skills').placeholder= "Separate skills by commas";à
      }*/
        document.querySelector(".add-budget").style.border = ".5px solid red";
      } else {
        // CHANGE BTN CONTENT
        document.querySelector(
          ".addproject-btn"
        ).innerHTML = `<span class="spinner-grow spinner-grow-sm text-white" role="status" aria-hidden="true"></span>
          Please Wait...`;

        // ADD PROJECT
        this.$http({
          method: "post",
          url: link.baselink + `/project/post/${this.token}`,
          data: {
            title: this.title,
            description: this.description,
            skills: this.skills,
            budget: this.budget,
          },
        })
          .then((res) => {
            // RELOAD WINDOW
            if (res.data.posted) {
              // RELOAD WINDOW
              window.location.reload();
            }
          })
          .catch(() => {
            // Something Goes Here...

            // CHANGE BUTTON BACK CONTENT
            document.querySelector(".addproject-btn").innerHTML = `Add Project`;

            // SHOW ALERT MESSAGE
            this.errMsg = "Something went wrong! Try Again.";
            this.err = true;

            // CHANGE BUTTON BACK CONTENT
            document.querySelector(".addproject-btn").innerHTML = `Add Project`;

            // HIDE ALERT AFTER 3 SECONDS
            window.setInterval(() => {
              this.errMsg = null;
              this.err = false;
            }, 5000);
          });

        // MAKE INPUTS EMPTY
        this.title = null;
        this.description = null;
        this.skills = null;
        this.budget = null;
      }
    },
    // delete project (proposals)
    deleteProject: function(ProjectTitle, index) {
      // CHANGE BTN CONTENT
      document.querySelector(
        ".delete-btn" + index
      ).innerHTML = `<span class="spinner-grow spinner-grow-sm text-white" role="status" aria-hidden="true"></span>
          Please Wait...`;
      // DELETE PROJECT BY TITLE
      this.$http({
        url: link.baselink + `/project/delete/${this.token}`,
        method: "post",
        data: {
          title: ProjectTitle,
        },
      })
        .then((res) => {
          // console.log(res);
          if (res.data.deleted) {
            // RELOAD WINDOW
            window.location.reload();
          }
        })
        .catch(() => {
          // CHANGE BUTTON BACK CONTENT
          document.querySelector(".delete-btn").innerHTML = `Delete`;

          // SHOW ALERT MESSAGE
          this.errMsg = "Something went wrong! Try Again.";
          this.err = true;

          // CHANGE BUTTON BACK CONTENT
          document.querySelector(".delete-btn").innerHTML = `Delete`;

          // HIDE ALERT AFTER 3 SECONDS
          window.setInterval(() => {
            this.errMsg = null;
            this.err = false;
          }, 5000);
        });
    },
    // update user info
    updateUserInfo: function() {
      // GRAB ALL INPUTS
      // WE CANNOT USE V-MODEL BESIDE :VALUE ATTRIBUTE, IF DOES VUE COMPILER WILL THROW AN ERROR

      const body = {
        name: document.querySelector("#name").value,

        email: document.querySelector("#email").value,

        phone: document.querySelector("#phone").value,

        address: document.querySelector("#address").value,

        zipCode: document.querySelector("#zipCode").value,

        city: document.querySelector("#city").value,

        country: document.querySelector("#country").value,

        skills: document.querySelector("#skills").value,

        languages : {

           motherLanguage: document.querySelector("#motherLanguage").value,

           secondLanguage: document.querySelector("#secondLanguage").value,

           thirdLanguage: document.querySelector("#thirdLanguage").value
           
        },

        password: document.querySelector("#password").value,

        // languages ...
      };

      // CHANGE BTN CONTENT
      document.querySelector(
        ".updateUserInfo"
      ).innerHTML = `<span class="spinner-grow spinner-grow-sm text-white" role="status" aria-hidden="true"></span>
            Please Wait...`;

      // VALIDATE INPUTS
      if (
        body.name == "" ||
        body.email == "" ||
        body.phone == "" ||
        body.address == "" ||
        body.zipCode == "" ||
        body.city == "" ||
        body.country == "" ||
        body.skills == "" ||
        body.password == ""
      ) {
        // SHOW ALERT MESSAGE
        this.errMsg = "Please fill all the inputs!";
        this.err = true;

        // CHANGE BUTTON BACK CONTENT
        document.querySelector(".updateUserInfo").innerHTML = `Save`;

        // HIDE ALERT AFTER 3 SECONDS
        window.setInterval(() => {
          this.errMsg = null;
          this.err = false;
        }, 5000);
      } else if (
        body.email.length < 10 &&
        !body.email.includes("@") &&
        !body.email.includes(".")
      ) {
        // SHOW ALERT MESSAGE
        this.errMsg = "Provide us a valid email!";
        this.err = true;

        // CHANGE BUTTON BACK CONTENT
        document.querySelector(".updateUserInfo").innerHTML = `Save`;

        // HIDE ALERT AFTER 3 SECONDS
        window.setInterval(() => {
          this.errMsg = null;
          this.err = false;
        }, 5000);
      } else if (!body.phone.match(this.phoneREGEX)) {
        // SHOW ALERT MESSAGE
        this.errMsg = "Provide us a valid phone number!";
        this.err = true;

        // CHANGE BUTTON BACK CONTENT
        document.querySelector(".updateUserInfo").innerHTML = `Save`;

        // HIDE ALERT AFTER 3 SECONDS
        window.setInterval(() => {
          this.errMsg = null;
          this.err = false;
        }, 5000);
      } else if (body.zipCode.length > 5 && typeof body.zipCode !== "number") {
        // SHOW ALERT MESSAGE
        this.errMsg = "Provide us a valid zip code!";
        this.err = true;

        // CHANGE BUTTON BACK CONTENT
        document.querySelector(".updateUserInfo").innerHTML = `Save`;

        // HIDE ALERT AFTER 3 SECONDS
        window.setInterval(() => {
          this.errMsg = null;
          this.err = false;
        }, 5000);
      } else if (body.password.length < 7) {
        // SHOW ALERT MESSAGE
        this.errMsg = "Try to use a strong password instead of a weak one!";
        this.err = true;

        // CHANGE BUTTON BACK CONTENT
        document.querySelector(".updateUserInfo").innerHTML = `Save`;

        // HIDE ALERT AFTER 3 SECONDS
        window.setInterval(() => {
          this.errMsg = null;
          this.err = false;
        }, 5000);
      } else {
        // SUBMIT USER DATA
        this.$http({
          url: link.baselink + `/dashboard/update/user/${this.token}`,
          method: "post",
          data: body,
        })
          .then((res) => {
            if (res.data.updated) {
              // CHANGE BUTTON BACK CONTENT
              document.querySelector(".updateUserInfo").innerHTML = `Save`;

              // SHOW ALERT MESSAGE
              this.successMsg = "Your Changes Saved Sucessfully!";
              this.msg = true;

              // CHANGE BUTTON BACK CONTENT
              document.querySelector(".updateUserInfo").innerHTML = `Save`;

              // HIDE ALERT AFTER 3 SECONDS
              window.setInterval(() => {
                this.successMsg = null;
                this.msg = false;
              }, 5000);
            }
          })
          .catch(() => {
            // alert(err.message);
            // CHANGE BUTTON BACK CONTENT
            document.querySelector(".updateUserInfo").innerHTML = `Save`;

            // SHOW ALERT MESSAGE
            this.errMsg = "Something went wrong!";
            this.err = true;

            // CHANGE BUTTON BACK CONTENT
            document.querySelector(".updateUserInfo").innerHTML = `Save`;

            // HIDE ALERT AFTER 3 SECONDS
            window.setInterval(() => {
              this.errMsg = null;
              this.err = false;
            }, 5000);
          });
      }
    },
    // tabs system
    switchTab: function() {
      // CHANGE TO SPECIFIC TAB
      document.querySelector(".projectsTab").classList.remove("display-none");
      document.querySelector(".projectsTab").classList.add("display-block");

      document
        .querySelector(".addProjectTab")
        .classList.remove("display-block");
      document.querySelector(".userInfoTab").classList.remove("display-block");

      document.querySelector(".addProjectTab").classList.add("display-none");
      document.querySelector(".userInfoTab").classList.add("display-none");
      // CLICKED BTN
      document.querySelector(".projectsBtn").classList.add("btnClicked");
      document.querySelector(".addProjectsBtn").classList.remove("btnClicked");
      document.querySelector(".userInfoBtn").classList.remove("btnClicked");
    },
    switchTab1: function() {
      // CHANGE TO SPECIFIC TAB
      document.querySelector(".addProjectTab").classList.remove("display-none");
      document.querySelector(".addProjectTab").classList.add("display-block");

      document.querySelector(".projectsTab").classList.remove("display-block");
      document.querySelector(".userInfoTab").classList.remove("display-block");

      document.querySelector(".projectsTab").classList.add("display-none");
      document.querySelector(".userInfoTab").classList.add("display-none");

      // CLICKED BTN
      document.querySelector(".projectsBtn").classList.remove("btnClicked");
      document.querySelector(".addProjectsBtn").classList.add("btnClicked");
      document.querySelector(".userInfoBtn").classList.remove("btnClicked");
    },
    switchTab2: function() {
      // CHANGE TO SPECIFIC TAB
      document.querySelector(".userInfoTab").classList.remove("display-none");
      document.querySelector(".userInfoTab").classList.add("display-block");

      document.querySelector(".projectsTab").classList.remove("display-block");
      document
        .querySelector(".addProjectTab")
        .classList.remove("display-block");

      document.querySelector(".projectsTab").classList.add("display-none");
      document.querySelector(".addProjectTab").classList.add("display-none");

      // CLICKED BTN
      document.querySelector(".projectsBtn").classList.remove("btnClicked");
      document.querySelector(".addProjectsBtn").classList.remove("btnClicked");
      document.querySelector(".userInfoBtn").classList.add("btnClicked");
    },
    // TOGGLE PASSWORD VISIBILITY
    togglePassword: function() {
      var x = document.querySelector(".passwordInput");
      if (x.type === "text") {
        x.type = "password";
      } else {
        x.type = "text";
      }
    },
  },
};
</script>

<style lang="css" scoped>
.side-bar {
  background-color: var(--bg-color-dark); /*rgba(0,0,0,.97);*/
  height: auto;
  min-height: 50vh;
  padding-right: 0 !important;
  padding-left: 0 !important;
  transition: all 0.2s ease-out;
}
.list {
  list-style: none;
  color: white;
  font-weight: bolder;
  margin-top: 50px;
  position: absolute;
  left: 0 !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  width: 100% !important;
  text-align: left;
}
.list-item {
  margin-left: 15px;
  cursor: pointer;
  padding-left: 20px !important;
  padding-right: 20px !important;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
  /*display: inline;*/
  padding: 5px;
}
.item-btn {
  margin-left: 15px;
  cursor: pointer;
  padding-left: 20px !important;
  padding-right: 20px !important;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
  /*display: inline;*/
  padding: 5px;
}
.item-btn:hover {
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  transition: all 0.2s ease-out;
}
.projectsTab,
.addProjectTab,
.userInfoTab {
  width: 100%;
  color: var(--text-color);
  /*overflow: scroll;*/
  /*height: 70%;*/
  border-radius: 3px;
}
.projectsTab {
  /*height: 600px !important;*/
  /*overflow: auto;*/
}
.display-none {
  display: none !important;
}
.display-block {
  display: block !important;
}
.projectTitle {
  font-weight: 100;
  color: rgba(0, 0, 0, 0.8);
}
.projectTitle {
  text-decoration: none !important;
}
.skill {
  margin: 3px;
  font-size: 10px;
  font-weight: 100;
}
.inline {
  display: inline;
  margin: 5px;
}
.project {
  border-left: 5px solid var(--primary-color) !important;
  border: 0.1px solid rgba(0, 0, 0, 0.1);
  border-radius: 3px;
  cursor: pointer;
}
.project:hover {
  transition: all 0.2s ease-out;
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2), 0 4px 11px 0 rgba(0, 0, 0, 0.11) !important;
}
.edit-btn,
.addproject-btn,
.update-btn {
  background-color: var(--primary-color);
  color: white !important;
}
.delete {
  background-color: var(--dan-ger);
  color: white;
}
.not-bold {
  font-weight: 100;
}
.modalBtns {
  position: relative;
  top: -15px;
}
.tabsSections {
  margin: 0 auto;
  border-radius: 3px;
}
.red {
  background-color: var(--dan-ger);
}
.primary {
  background-color: var(--primary-color);
}
.success {
  background-color: var(--succ-ess);
}
.add-description {
  height: 150px;
}
.update-desc {
  height: 200px !important;
}
.announcement {
  background-image: url(".././assets/codeJs.jpg");
  /*background-color: var(--primary-color);*/
  /*background-color: rgba(0,0,0,.92);*/
  /*background-attachment: ;*/
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  height: 170px;
  padding-top: 5%;
  padding-left: 4%;
  z-index: -1;
}
.content {
  height: 100% !important;
}
.btnClicked {
  background-color: var(--primary-color);
  color: white;
  transition: all 0.2s ease-out;
}
.no-data-svg {
  margin-top: 6%;
  margin-bottom: 6%;
}
.dynamic-svg {
  fill: var(--primary-color) !important;
}
.tabs-btns-right {
  padding-left: 30px !important;
  padding-right: 30px !important;
  border-radius: 3px;
}
.alert-smaller-devices {
  display: none;
}
.alert-larger-devices {
  display: block;
}
/*.dynamic-svg:hover {
  fill : var(--bg-color-dark);
}
/**
.title-of-each-tab {
  letter-spacing: .1px!important;
}.addproject-btn {
  position: relative;
  top :-30px;
}
*/
@media only screen and (max-width: 986px) {
  .hideable-text-item,
  .label {
    display: none !important;
  }
  .list {
    font-size: 30px !important;
    text-align: center;
  }
}
@media only screen and (max-width: 600px) {
  .hideable-text-item {
    display: block;
  }
  .project {
    height: 150px !important;
  }
  .modalBtns {
    top: 5% !important;
    position: relative;
  }
  .skills {
    width: 90% !important;
  }
  .skill {
    margin: 1px !important;
  }
  .project {
    padding: 15px !important;
  }
  .projectsTab,
  .addProjectTab,
  .userInfoTab {
    padding: 10px !important;
  }
  .list-item {
    font-size: 13px !important;
  }
  .list {
    padding-left: 10px !important;
  }
  .announcement {
    display: none;
  }
  .side-bar,
  .item-btn {
    display: none !important;
  }
  .btn-up {
    display: none !important;
  }
  .btn-down {
    display: block !important;
  }
  .title-of-each-tab,
  .icon-of-each-tab {
    font-size: 20px;
  }
  .add-project-first-tab {
    float: left !important;
  }
  .alert-smaller-devices {
    display: block;
  }
  .alert-larger-devices {
    display: none;
  }
}
@media screen and (max-width: 480px) {
  /* .side-bar {
    left: -500px;
    position: relative;
  }*/
}
</style>
